import { Group } from './SiteAndUnitsTable.types'
import { LocusesAndGroups } from '../PlanNewJob.types'

export const generateLocusesAndGroups = (
  data: Group[],
  selectedValues: string[],
) => {
  const result: LocusesAndGroups[] = []

  data.forEach(({ id: groupId, options }) => {
    const selectedOptions = options.filter(({ value }) =>
      selectedValues.includes(value),
    )
    const allOptionsSelected = selectedOptions.length === options.length

    if (allOptionsSelected) {
      result.push({ locusGroup: groupId })
    } else {
      const selectedLocuses = new Set<string>(
        selectedOptions.map(({ value }) => value.split('_')[0]),
      )
      options.forEach(({ value }) => {
        const locus = value.split('_')[0]
        if (selectedLocuses.has(locus)) {
          result.push({ locusGroup: groupId, locus: +locus })
        }
      })
    }
  })

  return result
}

export const generateValueFromLocusesAndGroups = (
  data: Group[],
  dataToConvert: LocusesAndGroups[],
): string[] => {
  const result: string[] = []

  dataToConvert.forEach(({ locusGroup, locus }) => {
    const group = data.find(({ id }) => id === locusGroup)

    if (group) {
      if (locus) {
        result.push(`${locus}_${locusGroup}`)
      } else {
        group.options.forEach(({ value }) => {
          result.push(`${value}`)
        })
      }
    }
  })

  return result
}
